import useAppQuery from 'hooks/useAppQuery';
import useAppUser from 'hooks/useAppUser';
import { GetDbsSettingsResponseTO } from 'models/DbsSettings';
import API from 'services/API';

export const DBS_SETTINGS_BASE_QUERY_KEY = 'dbsSettings';

export const DBS_SETTINGS_URL = '/api/internal/dbs-settings';

const useFetchDbsSettings = () => {
  const { agencyUid } = useAppUser();

  const { data, isInitialLoading, isError } = useAppQuery(
    [DBS_SETTINGS_BASE_QUERY_KEY, agencyUid],
    async () => {
      const response = await API.get<GetDbsSettingsResponseTO>(
        DBS_SETTINGS_URL,
        { params: { agencyUid } },
      );
      return response.data;
    },
    { enabled: !!agencyUid },
  );

  return {
    dbsSettings: data?.dbsSettings,
    isLoading: isInitialLoading,
    isError,
  };
};

export default useFetchDbsSettings;
